<!-- INIT ERROR -->
@if (initErrorFlag) {
  <div class="init-error-overlay">
    <div class="init-error-content">
      <p>Une erreur est survenue lors du chargement de l'application.</p>
      <button (click)="onRetry()" color="primary" mat-raised-button>Réessayer</button>
    </div>
  </div>
}

<!-- PROGRESS BAR -->
<app-progress-bar></app-progress-bar>
<!-- / PROGRESS BAR -->

<!-- VERTICAL LAYOUT 1 -->
@if (fuseConfig.layout.style === 'vertical-layout-1') {
  <app-vertical-layout-1></app-vertical-layout-1>
}
<!-- / VERTICAL LAYOUT 1 -->
